var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 512 462.75",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492 164.75a20 20 0 0 0-20 20v158a80 80 0 0 1-80 80H120a80 80 0 0 1-80-80v-178a80 80 0 0 1 80-80h167.26a67 67 0 1 0 1.4-40H120a120 120 0 0 0-120 120v178a120 120 0 0 0 120 120h272a120 120 0 0 0 120-120v-158a20 20 0 0 0-20-20z",
    fill: "green",
    opacity: 1,
    "data-original": "green",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7 175.28a45.74 45.74 0 0 0-46.51-.44A45.28 45.28 0 0 0 177 214.61v78.28a45.28 45.28 0 0 0 23.19 39.77 45.77 45.77 0 0 0 46.51-.44l65.86-39.14a45.69 45.69 0 0 0 0-78.66zm45.43 83.41-65.87 39.15s-5.11.73-6.29.05a5.52 5.52 0 0 1-3-5V214.6a5.53 5.53 0 0 1 3-5 6.05 6.05 0 0 1 6.29.06l65.87 39.14a5.7 5.7 0 0 1 0 9.89z",
    fill: "green",
    opacity: 1,
    "data-original": "green",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.f7bb8a029fa97914ddd483b730cd6c9c.svg";
export { ForwardRef as ReactComponent };